import { getScopedPath } from 'owa-url';
import { lazyInitializeNotificationManager } from 'owa-notification';
import { subscribe } from 'owa-group-association-notification';
import { groupAssociationChanged } from 'owa-calendar-cache';

// TODO: Remove this file after Tao completes his refactoring to move the initializeNotifications function from owa-mail to owa-notification
// and there is support for diagnostics panel for non-mail notifications
export default function initializeNotifications() {
    lazyInitializeNotificationManager
        .importAndExecute({
            channelEndpoint: getScopedPath('/owa') + '/notificationchannel',
            pingInterval: 300000,
            backoffMaximum: 64000,
            minimumReconnectInterval: 1000,
            readyCheckTimeout: 60000,
        })
        .then(subscribe.bind(null, groupAssociationChanged));
}
